import { render, staticRenderFns } from "./zklist.vue?vue&type=template&id=72a0c5c4&scoped=true&"
import script from "./zklist.vue?vue&type=script&lang=js&"
export * from "./zklist.vue?vue&type=script&lang=js&"
import style0 from "./zklist.vue?vue&type=style&index=0&id=72a0c5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0c5c4",
  null
  
)

export default component.exports